import { createImportJob, getStatusTask, startImportJob, getImportJob, startValidateFile } from './api-calls';

/** Display error for Import modal.
 *
 * @param {string} error - Error message.
 */
function displayImportError(error) {
  $('#closeImport').prop('disabled', false);
  $('#import-ring').removeClass('d-flex');
  $('#importErrorMsg').show();

  $('#importErrorText').empty();

  const errors = typeof error === 'string' ? error.split('\n') : error;

  errors.forEach(err => {
    $('#importErrorText').append(`<p class="mb-0">${err}</p>`);
  });
}

/** Display warning for Import modal.
 *
 * @param {string} warning - Warning message.
 */
function displayImportWarning(warning) {
  $('#importWarningMsg').show();

  const warnings = warning.split('\n');

  warnings.forEach(warn => {
    $('#importWarningText').append(`<p>${warn}</p>`);
  });
}

/**
 * Import job celery task by Id.
 *
 * @param {string} importJobId - Id of created import job.
 */
function importRawFile(importJobId) {
  startImportJob(importJobId).then((data) => {
    // Request status of running import job task every 500ms
    const imported = setInterval(() => {
      getImportJob(importJobId).then((data) => {
        // S - Successful import job
        if (data.status === 'S') {

          location.reload();
          // Clear input after finished import job
          $('#import-file').val('');

          // F - Failed import job
        } else if (data.status === 'F') {
          displayImportError(data.error_message);

          clearInterval(imported);
        }
      }).catch(error => {
        displayImportError(error);
        $('#import-file').prop('disabled', false);
        clearInterval(imported);
      });
    }, 2000);
  }).catch(error => {
    // If got error, display error message instead load icon
    displayImportError(error);
  });
}

/** Reset all messages for Import modal.
 * */
export function resetImportMessages() {
  // Reset warnings
  $('#importWarningMsg').hide();
  $('#importWarningText').text('');

  // Reset errors
  $('#importErrorMsg').hide();
  $('#importErrorText').text('');
}

/**
 * Validate uploaded file and allow import or display error.
 *
 * @param {string} importJobId - Id of created import job.
 */
export function validateFile(importJobId) {
  // Reset all messages for new uploaded file
  resetImportMessages();

  /** Check validation
   *
   * Get result of validation and display errors if it was added.
   * */
  function checkValidation() {
    const confirmImport = $('#confirmImport');

    getImportJob(importJobId).then((data) => {
      $('#import-file').prop('disabled', false);

      const errors = data.validation_errors_message;
      const warnings = data.validation_warning_message;

      if (!errors.length) {
        // Allow import if there are no errors in file
        confirmImport.prop('disabled', false);
        $('#importSpinner').prop('hidden', true);

        confirmImport.off('click').on('click', (e) => {
          $(this).prop('disabled', true);
          $('#closeImport').prop('disabled', true);
          $('#import-file').prop('disabled', true);
          $('#import-ring').addClass('d-flex');
          resetImportMessages();

          window.sessionStorage.clear();
          importRawFile(importJobId);
        });
      }

      if (errors.length) {
        $('#import-file').prop('disabled', false);
        $('#importSpinner').prop('hidden', true);
        displayImportError(errors);
      }

      if (warnings.length) {
        $('#import-file').prop('disabled', false);
        $('#importSpinner').prop('hidden', true);
        displayImportWarning(warnings);
      }

    }).catch(error => {
      $('#import-file').prop('disabled', false);
      $('#importSpinner').prop('hidden', true);
      displayImportError(error);
    });
  }

  startValidateFile(importJobId).then((data) => {
    const updated = setInterval(() => {
      getStatusTask(data.task_id).then((task) => {
        if (task.status === 'SUCCESS') {
          checkValidation();
          clearInterval(updated);
        } else if (task.status === 'FAILURE') {
          displayImportError(
            'Validation file was finished with unknown error'
          );
          clearInterval(updated);
        }
      }).catch(error => {
        displayImportError('Unknown import error');
        clearInterval(updated);
      });
    }, 1000);
  }).catch(error => {
    // If got error, display error message instead load icon
    displayImportError(error);
  });
}

/**
 * Call creating import job, upload file.
 *
 * @param {string} type - Type of import: shipment or invoice.
 * @param {object} importFile - File to import.
 */
export function uploadFileImportJob(type, importFile) {
  $('#import-file').prop('disabled', true);
  $('#importSpinner').prop('hidden', false);

  const formData = new FormData();

  // Create FormData with file data
  formData.append('data_file', importFile);
  formData.append('import_type', type);

  createImportJob(formData).then((data) => {
    // Validate file after uploading
    validateFile(data.id);
  }).catch(error => {
    $('#importSpinner').prop('hidden', true);
    $('#import-file').prop('disabled', false);
    displayImportError(error.responseJSON.data_file ? error.responseJSON.data_file : error);
  });
}
